const resizeTextures = (sprite) => {
  sprite.texture.baseTexture.updateSourceImage = true;
  sprite.texture.updateUvs();
};

// Restore the original texture size
const restoreTextureSize = (sprite) => {
  sprite.texture.baseTexture.updateSourceImage = false;
  sprite.texture.updateUvs();
};

// Resize the texture when entering full-screen mode
const enterFullscreen = (sprite) => {
  if (!document.documentElement.fullscreenElement) {
    if (document.documentElement.requestFullscreen) {
      document.documentElement.requestFullscreen();
    } else if (document.documentElement.mozRequestFullScreen) {
      document.documentElement.mozRequestFullScreen();
    } else if (document.documentElement.webkitRequestFullscreen) {
      document.documentElement.webkitRequestFullscreen();
    } else if (document.documentElement.msRequestFullscreen) {
      document.documentElement.msRequestFullscreen();
    }
    resizeTextures(sprite);
  }
};

// Restore the original texture size when exiting full-screen mode
const exitFullscreen = (sprite) => {
  if (document.exitFullscreen) {
    document.exitFullscreen();
  } else if (document.mozCancelFullScreen) {
    document.mozCancelFullScreen();
  } else if (document.webkitExitFullscreen) {
    document.webkitExitFullscreen();
  } else if (document.msExitFullscreen) {
    document.msExitFullscreen();
  }
  restoreTextureSize(sprite);
};

export { exitFullscreen, enterFullscreen };
